import _ from 'underscore';

var config = {
  formBackendUrl: 'https://www.formbackend.com/f/h1jspqvo'
};

switch (process.env.REACT_APP_STRIPE_MODE) {
  case 'live':
    config = _.extend(config, {
      apiKey: process.env.REACT_APP_STRIPE_PK_PROD,
    });
    break;
  default:
    config = _.extend(config, {
      apiKey: process.env.REACT_APP_STRIPE_PK_TEST,
    });
    break;
}

console.log('CLIENT process.env.REACT_APP_NODE_ENV', process.env.REACT_APP_NODE_ENV);

const exportConfig = config;
export default exportConfig;



// WEBPACK FOOTER //
// ./src/config.js